import { AppEnv } from './env.model';

/**
 * ENV DEV — serveur de développement partagé.
 * ⚠️ À CONFIGURER : remplace les URLs ci-dessous par celles du vrai backend dev
 * (API, storage, Reverb). Actif via `ng build|serve --configuration dev`.
 */
export const Env: AppEnv = {
  apiBaseUrl: 'https://dev.delivery.gisgoinc.com/api',
  storageBaseUrl: 'https://dev.delivery.gisgoinc.com/storage',

  reverb: {
    appKey: 'gisgo-key',
    host: 'ws.dev.delivery.gisgoinc.com',
    port: 443,
    // TLS obligatoire : Reverb est derrière un proxy qui termine le TLS sur
    // 443 (wss). Vérifié : wss → 101 en 202 ms, ws → handshake échoué en 31 ms.
    useTLS: true,
  },
};
